export default __webpack_public_path__ + "static/media/mileshow.24e90f36.svg";